// extracted by mini-css-extract-plugin
export default {"navbar":"navbar--qox2p","navbar_scrolled":"navbar_scrolled--Vbn3U","menu":"menu--hGfqE","hamburger":"hamburger--QReBZ","menu_opened":"menu_opened--PPj9B"};